import env from "@/common/env.js";
import { mapGetters } from 'vuex'
import { mta } from "@/utils/mta/uni-router.js";
import { createRouteMap } from "@/utils/mta/route.js";
import { posterInit } from "@/utils/posterInit.js"
export default {
	install(Vue) {
		Vue.mixin({
			data() {
				return {
					jx_page: 1,
					jx_page_count: 0, // 总页数
					jx_limit: 5, // 每页加载的条数
					jx_loadStatus: 'loadmore', // 加载的状态
					static_img_url: env.STATIC_DOMAIN,
					// textColors: '', // 系统颜色
					default_avatar: env.STATIC_DOMAIN + 'default_picture.png', // 默认头像
					default_bg: env.STATIC_DOMAIN + 'app_default_bg.png', // 页面背景图
					jx_total_status: false
				}
			},
			created() {
				// this.globalSet('textCol') || 
				// this.textColors = '#DB0505'
			},
			computed: {
				...mapGetters({
					mall_config: 'initConfig',
					textColors: 'initColor'
				})
			},
			onLoad(options) {
				if (options.pid) {
					uni.setStorageSync('pid', options.pid)
				}
				if(options.mtaShareFlag){ // 埋点的分享标识 - 用完立即清除 - 刷新既没
					mta.pushShareData(createRouteMap())
				}

				if (JSON.stringify(this.mall_config) != '{}') {
					this.$share.initShareUrl(this.mall_config.share)
				}

				
				posterInit(options); // 海报分享
			},
			onReachBottom() {
				try {
					this.jx_total_status = true
					if (this.jx_page >= this.jx_page_count) {
						return;
					}
					this.jx_loadStatus = 'loading'
					this.jx_page++
					this.refresh()
				} catch(e) {
					this.jx_loadStatus = 'nomore'
					console.error('上拉失败:', e);
				}
			},
			onPullDownRefresh() {
				this.jx_page = 1
				this.jx_total_status = false
				this.refresh()
			},
			methods: {
				jxGetList(url, showLoading = false, callback, data = {}) { // 分页
					let obj = {
						page: this.jx_page,
						limit: this.jx_limit
					}
					this.$http.request({
						url,
						showLoading,
						method: 'get',
						data: Object.assign(obj, data)
					}).then(res => {
						if (res.code == 0) {
							this.jx_page_count = res.data.page_count
							if (this.jx_page == this.jx_page_count) {
								this.jx_loadStatus = 'nomore'
							}
							uni.stopPullDownRefresh()
							callback(res)
						} else {
							this.$http.toast(res.msg)
						}
					})
				},
				refresh() {},
				initAppParams(options){
					//console.log('App Launch', options);
					let mall_default_sign = options.mall_default_sign;
					let from = options.from;
					if(options.query.from){
						 from = options.query.from;
					}
					switch(from){
						case 'mp-weixin-webview'://来自小程序webview
							let token = options.token;
							uni.setStorageSync('sign', mall_default_sign);
							uni.setStorageSync('token', token);
							uni.setStorageSync('from', from);
						break;
						case 'mp-weixin-order'://来自小程序webview
							uni.setStorageSync('sign', options.query.sign);
							uni.setStorageSync('token', options.query.token);
							uni.setStorageSync('from', options.query.from);
						break;
						default:
							//console.log('SIGN', mall_default_sign);
							// 小程序打包sign改这里






							

							let sign = this.$route.query.sign || uni.getStorageSync('sign') || mall_default_sign
							if (sign !== uni.getStorageSync('sign')) {
								uni.setStorageSync('sign', sign);
								this.clearStore()
							}
							// if (isWeChat()) {
							// 	this.$wechatSdk.initJssdk()
							// }
							

							



							



							this.initMall();
					}
				},
				initMall() {
					if(Date.now()>uni.getStorageSync('mall_config_time')){
						this.$http.request({
							url: this.$api.setting.mall_config,
							method: 'POST'
						}).then(res => {
							console.log(33355);
							if (res.code === 0) {
								let config = res.data;
								uni.setStorageSync('mall_config', config);
								let mall_config_time = Date.now()+1000*60*5; 
								uni.setStorageSync('mall_config_time', mall_config_time);
								uni.setStorageSync('tabbars', JSON.stringify(config.navbar));
								this.$store.commit('setMallConfig', config)
								this.$store.commit('setGlobalColor', this.setColor(config.global_text_color))
								share.init()
							}
						});
					}else{
						let mall_config = uni.getStorageSync('mall_config');
						this.$store.commit('setMallConfig', mall_config)
						uni.setStorageSync('tabbars', JSON.stringify(mall_config.navbar));
						this.$store.commit('setGlobalColor', this.setColor(mall_config.global_text_color))
						share.init()
					}
					//console.log(mall_config.global_text_color,9999);
				},
			},
			onShareAppMessage() {
				return this.$share.initShareUrl(this.mall_config.share)
			},
		})
	}
	
}